import { graphql } from "@opensea/graphql"
import { CurrencyChartColorFragment } from "./CurrencyChartColorProvider.fragment"
import { CurrencyInfoFragment } from "./CurrencyInfo.fragment"
import { TradingViewChartButtonFragment } from "./TradingViewChart/TradingViewChart.fragment"

export const CurrencyChartFragment = graphql(
  `
    fragment CurrencyChart on Currency {
      contractAddress
      chain {
        identifier
      }
      imageUrl
      ...CurrencyInfo
      ...CurrencyChartColor
      ...TradingViewChartButton
    }
  `,
  [
    CurrencyInfoFragment,
    CurrencyChartColorFragment,
    TradingViewChartButtonFragment,
  ],
)
